import { render, staticRenderFns } from "./tableFormOrder.vue?vue&type=template&id=639b61ed&"
import script from "./tableFormOrder.vue?vue&type=script&lang=js&"
export * from "./tableFormOrder.vue?vue&type=script&lang=js&"
import style0 from "./tableFormOrder.vue?vue&type=style&index=0&id=639b61ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports